(function () {
  if (window.__ingreFragrToggleInitialized) return;
  window.__ingreFragrToggleInitialized = true;

  const toggleItems = document.getElementsByClassName('toggle-item');
  const panels = document.getElementsByClassName('ingredients-fragrances-toggle-item');

  Array.from(toggleItems).forEach((element) => {
    element.addEventListener('click', function () {
      const targetId = element.getAttribute('data-target');
      if (!targetId) return;

      clearOtherSelected();
      element.classList.add('toggle-item-selected');

      Array.from(panels).forEach((panel) => {
        if (panel.id === targetId) {
          panel.classList.remove('hidden');
        } else {
          panel.classList.add('hidden');
        }
      });
    });
  });

  function clearOtherSelected() {
    Array.from(toggleItems).forEach((element) => element.classList.remove('toggle-item-selected'));
  }
})();
